import { useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

const newNode = () => {
  const node = document.createElement("div");
  document.body.appendChild(node);
  return node;
};

const DefaultPortal = ({ children }) => {
  const [node, setNode] = useState(null);
  useLayoutEffect(() => {
    const myNode = newNode();
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setNode(myNode);
    return () => document.body.removeChild(myNode);
  }, []);
  return node && createPortal(children, node);
};

export default DefaultPortal;
